import type {
  ApiQuestionnaireResults,
  UiQuestionnaireResults,
  UiQuestionnaireQuestionResult,
} from '../../schemas/questionnaireResults.schema';

function mapQuestionnaireQuestionResultFromApi(
  question: ApiQuestionnaireResults['questions'][number],
): UiQuestionnaireQuestionResult {
  return {
    id: question.id,
    questionText: question.questionText,
    description: question.description,
    answerType: question.answerType,
    isRequired: question.isRequired,
    order: question.order,
    unitLabel: question.unitLabel,
    totalAnswers: question.totalAnswers,
    textAnswers: question.textAnswers,
    numericStats: question.numericStats,
    optionStats: question.optionStats,
  };
}

export function mapQuestionnaireResultsFromApi(
  api: ApiQuestionnaireResults,
): UiQuestionnaireResults {
  return {
    summary: {
      submissionsCount: api.summary.submissionsCount,
      peopleCount: api.summary.peopleCount,
      avgPerPerson: api.summary.avgPerPerson,
    },
    questions: [...api.questions]
      .sort((a, b) => a.order - b.order)
      .map(mapQuestionnaireQuestionResultFromApi),
  };
}
